module.exports = __webpack_public_path__ + "static/media/italic.a8be3d04.svg";